const state = {
    idea_id:0,
    status:0,
}
const getters = {
    idea_id: state => state.idea_id,
    idea_status: state => state.status,
}
const mutations = {
    currentIdeaId(state, update) {
        state.idea_id = update
    },
    currentStatus(state, update) {
        state.status = update
    },
  };
const actions = {
    setIdeaId({commit}, idea_id) {
        commit('currentIdeaId',idea_id)
    },
    setideaStatus({commit}, status) {
        commit('currentStatus',status)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
